import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { FileUploadModule } from 'ng2-file-upload';
import { NmdpWidgetModule } from '@nmdp/nmdp-login';

import { AppComponent } from './app.component';
import { FileRecordComponent } from './records/file-record.component';
import { HomeComponent } from './home/home.component';
import { NavbarComponent } from './navbar/navbar.component';
import { FooterComponent } from './footer/footer.component';
import { UploaderComponent } from './uploader/uploader.component';
import { DataTableComponent } from './data-table/data-table.component';
import { CsvConverterService } from './converter/csv-converter.service';
import { FileRecordService } from './records/file-record.service';
import { HmlValidationService } from './validation/hml-validation.service';
import { ModalModule } from 'ngx-bootstrap/modal';
import { ModalComponent } from './modal/modal.component';
import { ThrobberComponent } from './records/throbber.component';
import { ValidationErrorsComponent } from './data-table/validation-errors.component';
import { HttpClientJsonpModule, HttpClientModule} from "@angular/common/http";
import {NgbModule} from "@ng-bootstrap/ng-bootstrap";
import {MatIconModule} from '@angular/material/icon';
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";

@NgModule({
  imports: [
    BrowserModule,
    CommonModule,
    FileUploadModule,
    NgbModule,
    FormsModule,
    HttpClientModule,
    HttpClientJsonpModule,
    BrowserAnimationsModule,
    MatIconModule,
    ModalModule.forRoot(),
    NmdpWidgetModule.forRoot(window.location.pathname + 'assets/HMLUploader-login.json')
  ],

  declarations: [
    AppComponent,
    FileRecordComponent,
    HomeComponent,
    NavbarComponent,
    FooterComponent,
    UploaderComponent,
    DataTableComponent,
    ModalComponent,
    ThrobberComponent,
    ValidationErrorsComponent
  ],
  schemas:[CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    CsvConverterService,
    FileRecordService,
    HmlValidationService
  ],
  bootstrap: [ AppComponent ]
})
export default class AppModule {
}
